import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=2aa21d90&scoped=true"
import script from "./CustomerOrder.vue?vue&type=script&lang=js"
export * from "./CustomerOrder.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrder.vue?vue&type=style&index=0&id=2aa21d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa21d90",
  null
  
)

export default component.exports